import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { CompactHeader } from '@vio/atlas/CompactHeader';
import { useIsReferralProgramEnabled } from '@vio/atlas/hooks/useIsReferralProgramEnabled';
import { BrandLogo } from '@vio/shared/src/whiteLabel/BrandLogo/BrandLogo';
import { MobileHeaderMenu } from 'components/MobileHeader/MobileHeaderMenu';
import { SearchFormMobile } from 'components/SearchBox/Home/SearchFormMobile';
import { SearchSummaryButtonWithStore } from 'components/SearchSummaryButtonWithStore';
import { useIsPageSearchBoxOpen } from 'hooks/searchBox';
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay';
import { OverlayType } from 'modules/overlay/types';
import { SearchBoxAncestor } from 'modules/searchBox/types';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { Entity, Team } from '@daedalus/core/src/analytics/types/Events';
import { getUser, selectAuthEnabled } from '@daedalus/core/src/auth/modules/selectors';
const BottomContentWrapper = /*#__PURE__*/styled('div')({
  name: "BottomContentWrapper",
  class: "b1szcgl",
  propsAsIs: false
});
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h136bigd",
  propsAsIs: false
});
export interface Props {
  className?: string;
  hasShadow?: boolean;
  hasDivider?: boolean;
  hasHeaderSearchSummary?: boolean;
}
export const BaseHomeMobileHeader = memo(({
  className,
  hasShadow = false,
  hasDivider = false,
  hasHeaderSearchSummary = false
}: Props) => {
  const showOverlay = useShowOverlay();
  const {
    brand
  } = useBrand();
  const user = useSelector(getUser);
  const authEnabled = useSelector(selectAuthEnabled);
  const isInviteFriendsTab = useIsReferralProgramEnabled(brand);
  const isPageSearchBoxOpen = useIsPageSearchBoxOpen();
  const handleShowPreferences = () => {
    showOverlay({
      type: OverlayType.Preferences,
      entity: Entity.PreferencesOverlay,
      team: Team.Retention,
      payload: {
        isInviteFriendsTab
      }
    });
  };
  return <HeaderWrapper>
        <CompactHeader className={className} brand={brand} hasShadow={hasShadow} hasDivider={hasDivider} BrandLogoComponent={BrandLogo} centerContent={hasHeaderSearchSummary && !isPageSearchBoxOpen && <SearchSummaryButtonWithStore ancestor={SearchBoxAncestor.Page} />} endContent={<MobileHeaderMenu shouldShowUserAvatar={authEnabled} user={user} onShowPreferences={handleShowPreferences} />} bottomContent={hasHeaderSearchSummary && isPageSearchBoxOpen && <BottomContentWrapper>
                <SearchFormMobile />
              </BottomContentWrapper>} hasBrandBackground />
      </HeaderWrapper>;
});
BaseHomeMobileHeader.displayName = 'BaseHomeMobileHeader';

require("./BaseHomeMobileHeader.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BaseHomeMobileHeader.tsx");